.bam-field-link {
    text-decoration: none;
}

.bam-field-underline {
    text-decoration: underline;
}
